export default "__VITE_ASSET__d4d59d82__"